import { render, staticRenderFns } from "./Questionnaire_Inform.vue?vue&type=template&id=65ab919c&scoped=true&"
import script from "./Questionnaire_Inform.vue?vue&type=script&lang=js&"
export * from "./Questionnaire_Inform.vue?vue&type=script&lang=js&"
import style0 from "./Questionnaire_Inform.vue?vue&type=style&index=0&id=65ab919c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ab919c",
  null
  
)

export default component.exports